import api from '../utils/api';

export const getAllSchools = (districtId) => {
  return api({
      url: '/api/districts/schools/get-all-schools/' + districtId,
    method: 'GET'
  })
}

export const getDistrictBySchoolId = (districtId, schoolId) => {
  return api({
      url: '/api/districts/schools/get-school/' + districtId + '/' + schoolId,
    method: 'GET'
  })
}

//export const updateSchool = (districtId, school) => {
//    let url = '/api/districts/schools/add-update-school/' + districtId;
   
//    return api.post(url, school)
//}
export const updateSchool = (districtId, school) => {
    let url = '/api/districts/schools/';
    if (school.baseId == null || school.baseId == 0) url += 'add-school';
    else url += 'edit-school';
    url += '/' + districtId;
    return api.post(url, school)
}


export const deleteSchool = (districtId, schoolId) => {
    return api.delete('/api/districts/schools/delete/' + districtId + '/' + schoolId);
}



export const getSchoolProductsBySchoolId = (schoolId) => {
    return api({
        url: `/api/districts/schools/get-school-products/${schoolId}`,
        method: 'GET'
    })
}

export const getSchoolProductOptionsBySchoolId = (schoolId) => {
    return api({
        url: `/api/districts/schools/get-school-product-options/${schoolId}`,
        method: 'GET'
    })
}


export const getAllDistrictSchoolsByUserId = (districtId, districtUserId) => {
    return api({
        url: `/api/districts/schools/get-district-schools-by-userId/${districtId}/${districtUserId}`,
        method: 'GET'
    })
}

export const getAll = () => {
    return api({
        url: '/api/districts/schools/get-all/',
        method: 'GET'
    })
}